import { apiClient } from "../../../base/ApiClient";


export const fetchPositions = async () => {
  const response = await apiClient.get("/communications/positions/");
  return response.data;
};

export const createPosition = async (positionName) => {
  const response = await apiClient.post("/communications/positions/", { name: positionName });
  return response.data;
};